import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices";
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from 'api/queryClient';
import { ToastContainer } from 'react-toastify';
import { PermissionProvider } from '../src/context/PermissionContext';
import { StudyProvider } from '../src/context/StudyContext';
import { DateFormatProvider } from '../src/context/DateFormatContext';

const store = configureStore({ reducer: rootReducer, devTools: true });

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <React.Fragment>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <QueryClientProvider client={queryClient}>
          <PermissionProvider>
            <StudyProvider>
              <DateFormatProvider>
                <ToastContainer/>
                <App />
              </DateFormatProvider>
            </StudyProvider>
          </PermissionProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </React.Fragment>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();